"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _react = _interopRequireDefault(require("react"));
var _config = require("./storybook/config");
var _footerModule = _interopRequireDefault(require("./footer.module.scss"));
var Footer = function Footer(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? _config.footerItems : _ref$items;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: _footerModule.default['footer']
  }, items.map(function (_ref2) {
    var id = _ref2.id,
      href = _ref2.href,
      title = _ref2.title;
    return /*#__PURE__*/_react.default.createElement("span", {
      key: id,
      className: _footerModule.default['footer-item']
    }, href && /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      target: "_blank",
      rel: "noopener noreferrer"
    }, title), !href && title);
  }));
};
exports.Footer = Footer;